import { render, staticRenderFns } from "./CmgLoyaltyRewardCard.vue?vue&type=template&id=7605b815&scoped=true&lang=pug&"
import script from "./cmg-loyalty-reward-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-reward-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyRewardCard.vue?vue&type=style&index=0&id=7605b815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7605b815",
  null
  
)

export default component.exports